import { useContext } from 'react'
import { AuthContext } from './auth'
import { BrandVoiceContext } from './brandVoice'
import { BreadCrumbsContext } from './breadcrumbs'
import { FileContext } from './file'
import { FormContext } from './form'
import { LayoutPreferenceContext } from './layoutPreference'
import { SequenceContext } from './sequence'
import { SocketContext } from './socket'
import { SubscriptionContext } from './subscription'
import { DataMapperContext } from './tagMapper'

export const useAuthContext = () => useContext(AuthContext)
export const useDataMapperContext = () => useContext(DataMapperContext)
export const useBreadcrumbContext = () => useContext(BreadCrumbsContext)
export const useSubscriptionContext = () => useContext(SubscriptionContext)
export const useSocketContext = () => useContext(SocketContext)
export const useFileContext = () => useContext(FileContext)
export const useLayoutPreference = () => useContext(LayoutPreferenceContext)
export const useBrandVoiceContext = () => useContext(BrandVoiceContext)
export const useFormContext = () => useContext(FormContext)
export const useSequenceContext = () => useContext(SequenceContext)
